module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "int"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Jewelry artists have the unique ability to bend perception, push limits")]), _vm._v(", and redefine wearable art. Personal adornment is a broad, diverse, and limitless craft. Original, inventive, and artistically designed—this is what makes great jewelry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We all create objects that speak volumes about our innermost feelings and thoughts. To create work that speaks louder than words, though, you need a foundation, which is why this book is in your hands. "), _c('em', [_vm._v("The Jeweler’s Studio Handbook")]), _vm._v(" teaches you the core techniques, introduces you to the materials, and hands you the tools needed to flourish in the jewelry-making studio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In these pages you will tour the artisan studio, inside and out, learning along the way how to express yourself through the tactile, versatile, and ancient craft of making metal jewelry. Illustrating everything from drill bits to silvermith’s hammers and onward to scores of nontraditional materials, the pages of this book are rich, hardworking, and inspiring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For me, writing gives me the same feeling of creation that making jewelry does, sharing my experiences and teaching the processes and techniques. This book is an opportunity for me to communicate to you the same ideas my work conveys visually ߮ and I learn more and more about the craft "), _c('em', [_vm._v("myself")]), _vm._v(" along the way. The rush of ideas that stems from teaching, the questions you might not always think to ask of yourself—both enrich you as artist and as teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I encourage you to experiment. Learn from your mistakes. There is inherent value in creating the unexpected; you will always learn best by trying and doing. May "), _c('em', [_vm._v("The Jeweler’s Studio Handbook")]), _vm._v(" refine your skills, better your designs, and facilitate your creative process.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282671aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00f_introduction.vue
// module id = 72
// module chunks = 0